import { render, staticRenderFns } from "./VariantForm.vue?vue&type=template&id=cf4750ca&"
import script from "./VariantForm.vue?vue&type=script&lang=js&"
export * from "./VariantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports